<template>
  <div v-if="activeType == 1">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option" v-for="(item,i) in answer_data" :key="i">
      <span class="answer-option-sort">{{optionMap[i]}}.</span>
      <span class="answer-option-content">
        {{item.content}}
        <viewer :images="item.file">
          <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </span>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        {{optionMap[parsing.answer]}}
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
  </div>
  <div v-else-if="activeType == 2">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option" v-for="(item,i) in answer_data" :key="i">
      <span class="answer-option-sort">{{optionMap[i]}}.</span>
      <span class="answer-option-content">
        {{item.content}}
        <viewer :images="item.file">
          <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </span>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        {{parsing.answer | capitalize}}
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
  </div>
  <div v-else-if="activeType == 3">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option">
      <el-radio name="answer" v-model="parsing.answer" :label="1" :disabled="parsing.answer==2?true:false">正 确</el-radio>
      <el-radio name="answer" v-model="parsing.answer" :label="2" :disabled="parsing.answer==1?true:false">错 误</el-radio>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        {{parsing.answer==1?'正确':'错误'}}
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
  </div>
  <div v-else-if="activeType == 4">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option" v-for="(item,i) in answer_data" :key="i">
      <span class="answer-option-sort">{{i+1}}.</span>
      <span class="answer-option-content">
        <el-input type="text" placeholder="请输入答案" size="mini" style="display: inline-block;width: 200px;" :disabled="true"></el-input>
      </span>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        <p v-for="(item,idx) in answer_data" :key="idx">
          第{{idx+1}}空：{{item.content}}
          <viewer :images="item.file">
            <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
          </viewer>
        </p>
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
  </div>
  <div v-else-if="activeType == 5">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
  <div v-else-if="activeType == 6">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
  <div v-else-if="activeType == 7">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option">
      <el-input type="textarea" placeholder="请输入答案" :rows="1" :disabled="true"></el-input>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        {{answer_data.content}}
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
  </div>
  <div v-else-if="activeType == 8">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option">
      <el-input type="textarea" placeholder="请输入答案" :rows="1" :disabled="true"></el-input>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        {{answer_data.content}}
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>

    </div>
  </div>
  <div v-else-if="activeType == 9">
    <div class="answer-option" v-html="training_introduce"></div>
    <div class="show-more">
      <span @click="showMore=!showMore" v-if="!showMore">展开更多<i class="el-icon-arrow-right"></i></span>
      <span @click="showMore=!showMore" v-if="showMore">收起<i class="el-icon-arrow-down"></i></span>
    </div>
    <div class="question-desc" v-if="showMore">
      <template v-if="training_url">
        <div v-for="(tr,idx) in training_url" class="question-train-url" :key="idx">
          <div class="question-option-video" v-if="jugeMaterialType(tr.name)==='video'">
            <video controls="controls" :src="tr.url"></video>
          </div>
          <div class="question-option-img" v-else-if="jugeMaterialType(tr.name)==='img'">
            <img :src="tr.url" />
          </div>
          <div class="question-option-app" v-else-if="jugeMaterialType(tr.name)==='word'">
            <p>教学文件：</p>
            <span></span><a :href="tr.url" :download="tr.name" target="_blank">{{tr.name}}</a>
          </div>
        </div>
      </template>
      <div class="question-option-material" v-if="materials.length">
        <div class="download-menu">
          <i class="el-icon-download"></i> 参考资料
        </div>
        <div slot="tip" class="el-upload__tip" style="display: inline-block; ">（下载所需资料）</div>
        <ul>
          <li v-for="(item,i) in materials" :key="i">
            <span></span><a :href="item.url" :download="item.name" target="_blank">{{item.name}}</a>
          </li>
        </ul>
      </div>
      <i class="divider-line"></i>
      <div class="question-option-material" v-if="training_tool.length">
        <h2>实训工具</h2>
        <ul>
          <li v-for="(item,i) in training_tool" :key="i">
            <span></span>
            <img :src="item.image" v-if="item.url!=='null'" style="width: 20px;height: 20px;position: relative;top: 3px;" />
            {{item.name}}
          </li>
        </ul>
      </div>
      <i class="divider-line"></i>
      <div class="question-train-steps">
        <h2>实训步骤</h2>
        <div class="train-steps-item" v-for="(item,i) in training_steps" :key="i">
          <span class="steps-num">{{i+1}}</span>
          <div class="item-content" v-html="item.content"></div>
          <img v-for="(img,idx) in item.file" :src="img.url" :key="idx" />
          <span class="steps-end" v-if="i===training_steps.length-1">END</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="activeType == 10">
    <div class="answer-title">
      <div v-html="topic_title.content"></div>
      <viewer :images="topic_title.file">
        <img v-for="(src,index) in topic_title.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="answer-option" v-for="(item,i) in answer_data" :key="i">
      <span class="answer-option-sort">{{optionMap[i]}}.</span>
      <span class="answer-option-content">
        {{item.content}}
        <viewer :images="item.file">
          <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </span>
    </div>
    <div class="answer-list" v-show="showAnswer">
      <div class="answer-list-li">
        <span>答案</span>
        {{parsing.answer | sortOption}}
      </div>
      <div class="answer-list-li">
        <span>解析</span>
        {{parsing.content}}
        <viewer :images="parsing.file">
          <img v-for="(src,index) in parsing.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/main'
// 导入组件
export default {
  components: {
    ElImageViewer
  },
  props: ['activeType', 'answerData', 'isParsing'],
  data() {
    return {
      showMore: false,
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H', 8: 'I', 9: 'J',
      },
      showAnswer: true,
      answer_data: [],
      parsing: [],
      topic_title: [],
      materials: [],
      training_introduce: '',
      training_steps: [],
      training_tool: [],
      training_url: []
    }
  },
  mounted() {
    if (this.activeType == 9) {
      this.resetData()
      //				this.answer_data=this.answerData
      this.materials = this.answerData.materials,
        this.training_introduce = this.answerData.training_introduce
      this.training_steps = this.answerData.training_steps,
        this.training_tool = this.answerData.training_tool,
        this.training_url = this.answerData.training_url
    } else {
      this.resetData()
      this.answer_data = this.answerData.answer
      this.parsing = this.answerData.parsing
      this.topic_title = this.answerData.topic_title
    }
  },
  watch: {
    activeType: function () {
      if (this.activeType == 9) {
        this.resetData()
        //					this.answer_data=this.answerData
        this.materials = this.answerData.materials,
          this.training_introduce = this.answerData.training_introduce
        this.training_steps = this.answerData.training_steps,
          this.training_tool = this.answerData.training_tool,
          this.training_url = this.answerData.training_url
      } else {
        this.resetData()
        this.answer_data = this.answerData.answer
        this.parsing = this.answerData.parsing
        this.topic_title = this.answerData.topic_title
      }
    },
    isParsing: function () {
      this.showAnswer = this.isParsing
    }
  },
  methods: {
    resetData: function () {
      this.answer_data = []
      this.parsing = []
      this.topic_title = []
      this.showMore = false
      this.materials = []
      this.training_introduce = ''
      this.training_steps = []
      this.training_tool = []
      this.training_url = []
    },
    resetShowAnswer: function () {
      this.showAnswer = !this.showAnswer
    },
    //判断教学材料类型，图片/视频/文件
    jugeMaterialType: function (name) {
      if (!name) return
      let imgArr = ['.jpg', '.jpeg', '.png', '.gif']
      let videoArr = ['.mp4']
      let type = ''
      for (let i = 0; i < imgArr.length; i++) {
        if (name.indexOf(imgArr[i]) > -1) {
          type = 'img'
        }
      }
      if (!type) {
        for (let j = 0; j < videoArr.length; j++) {
          if (name.indexOf(videoArr[j]) > -1) {
            type = 'video'
          }
        }
      }
      if (!type) {
        type = 'word'
      }
      return type
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        str += ' ' + arr[value[i]] + ' '
      }

      return str
    },
    //排序题答案排序
    sortOption: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        if (i >= value.length - 1) {
          str += ' ' + arr[value[i]]
        } else {
          str += ' ' + arr[value[i]] + ' ->'
        }
      }
      return str
    }
  }
}
</script>
<style scoped="">
.answer-option {
  padding: 0 10px;
  line-height: 25px;
  margin: 10px 0;
  overflow: hidden;
}
.answer-option .answer-option-sort {
  width: 20px;
  display: inline-block;
}
.answer-option .answer-option-content {
  word-break: break-all;
}
.answer-title {
  background-color: #fdfbfc;
  line-height: 25px;
  padding: 0 10px;
}
.answer-list {
  padding: 0 10px;
  width: 100%;
  border-top: 1px dashed #dce1e6;
  box-sizing: border-box;
  /*margin-top: 20px;*/
}
.answer-list .answer-list-li {
  line-height: 40px;
  margin: 10px 0;
}
.answer-list .answer-list-li span {
  padding: 3px 8px;
  border: 1px solid #ed895a;
  background-color: #ed895a;
  color: #ffffff;
}

.question-desc {
  padding: 10px 20px;
  box-sizing: border-box;
}
.question-option-video {
  width: 100%;
  box-sizing: border-box;
}
.question-option-video video {
  width: 100%;
}

.show-more {
  padding: 0 20px;
  margin: 10px 0;
}
.show-more span {
  color: #409eff;
  cursor: pointer;
}
.train-title img {
  width: 950px;
}

.question-option-material {
  margin: 20px 0;
}
.download-menu {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  display: inline-block;
  color: #ffffff;
  border-radius: 5px;
  background-color: #67c23a;
}
.question-option-material ul li {
  line-height: 20px;
  margin: 10px 0;
  /*list-style: inside;*/
}
.question-option-material ul li span,
.question-option-app span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #409eff;
  margin-right: 10px;
}
.question-train-steps {
  margin: 20px 0;
  box-sizing: border-box;
}
.question-train-steps .item-content {
  margin: 10px 0;
  overflow: hidden;
}
.question-train-steps .train-steps-item {
  padding: 0 0 10px 20px;
  box-sizing: border-box;
  border-left: 1px dashed #dce1e6;
  position: relative;
}

.question-train-steps .train-steps-item .steps-num {
  display: block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  color: #ffffff;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: -8px;
  left: -13px;
  background-color: #409eff;
}
.question-train-steps .train-steps-item .steps-end {
  display: block;
  color: #c0c4cc;
  position: absolute;
  bottom: -10px;
  left: -15px;
}
.question-train-steps h2 {
  margin: 20px 0;
}
.question-train-steps img {
  max-width: 100%;
  display: block;
  margin: 5px 0;
}
.answer-option /deep/ p {
  overflow: hidden;
}
</style>